
import BaseCard from '@/components/Card/BaseCard.vue';
import BaseBadge from '@/components/Badge/BaseBadge.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HealthCheckModal',
  components: { BaseBadge, BaseCard }
});
